import useUser from '@alltrails/context/hooks/useUser';
import useUserLocation from '@alltrails/context/hooks/useUserLocation';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import { isTripPlannerEntryPointVisible } from '../utils/tripPlannerAvailability';
import { isTripPlannerSearchAreaFarAway, type TripPlannerSearchArea } from '../utils/tripPlannerSearchArea';

/** Whether a trip planner entry point should render for this user, ignoring the search area. */
export const useIsTripPlannerEntryPointVisible = () =>
  isTripPlannerEntryPointVisible({ experiments: useExperiments(), languageRegionCode: useLanguageRegionCode(), user: useUser() });

/**
 * Whether a trip planner entry point should render for the area currently being searched.
 */
export const useIsTripPlannerAvailableForArea = ({ mapBounds, mapCenter }: TripPlannerSearchArea = {}) => {
  const experiments = useExperiments();
  const languageRegionCode = useLanguageRegionCode();
  const user = useUser();
  const userLocation = useUserLocation();

  if (!isTripPlannerEntryPointVisible({ experiments, languageRegionCode, user })) {
    return false;
  }

  // always show entry point for v2
  return experiments['web-disco-rm-trip-planner-v2']?.value === 'on' || isTripPlannerSearchAreaFarAway({ mapBounds, mapCenter, userLocation });
};
